import React, { useEffect, useState } from "react";

import { Modal } from "react-bootstrap";

import styles from "./accountManagementModal.module.css";
import ReasonRejectModalWindow from "../../../../components/GeneralComponents/reasonRejectModalWindow/ReasonRejectModalWindow";

const AccountManagementModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  text,
  typeModal,
}) => {
  const [isLockdownAccess, setIsLockdownAccess] = useState(false);
  const [reasonReject, setReasonReject] = useState("");
  
  const handleConfirmClick = () => {
    if (typeModal === "block") {
      setIsLockdownAccess(true);
    } else {
      handleConfirm(reasonReject);
    }
  };

  const handleCloseRejectModal = () => {
    setReasonReject("");
    setIsLockdownAccess(false);
    handleClose();
  };

  const handleReasonReject = (value) => {
    setReasonReject(value);
  };

  const handleRefuse = () => {
    setIsLockdownAccess(false);
    handleConfirm(reasonReject);
  };

  return isLockdownAccess && typeModal === "block" ? (
    <ReasonRejectModalWindow
      show={show}
      setShow={handleClose}
      headerText={"Введите причину блокировки:"}
      handleReasonReject={handleReasonReject}
      handleCloseRejectModal={handleCloseRejectModal}
      handleRefuse={handleRefuse}
      textareaPlaceholder={"Введите причину блокировки"}
    />
  ) : (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <p>{text}</p>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        <div className={styles["save-btn"]} onClick={handleConfirmClick}>
          Подтвердить
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountManagementModal;
